import VendorDetails from '../../../global/Components/VendorDetails/VendorDetails';
import styles from './VendorCard.module.scss';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Feedback from '../../../global/Components/Feedback/Feedback';

export default function VendorCard(props) {
  return (
    <vendor-card-component>
      <div className={`${styles.lgtBackground} ${styles.aboutVendor} mb-3`}>
        <div className={`bg-white ${styles.banner}`}>
            <div className={`${styles.cover}`} style={{backgroundImage: `url(images.png)`}}></div>
            <img 
              src={`${!props.data.avatar ? '/images.png' : `${process.env.REACT_APP_API_URL}${props.data.avatar}`}`} 
              className={`img-fluid bg-white ${styles.logo}`} 
            />
        </div>
        <div className={`${styles.info} bg-white p-4 pb-1`}>
          <div className={`d-flex`}>
            <div className={`${styles.sellerName} pb-2` }>
              {props.data.first_name && props.data.first_name}
              {' '}
              {props.data.last_name && props.data.last_name}
            <Link  to={`/vendor/${props.data.id}`}
                className={`${styles.username} text-decoration-none d-block`}>
                {props.data.username && props.data.username}
            </Link>
            </div>
          </div>
          <div className='bottonDivider mb-3'></div>
          <div  className='mb-3'>
            <Feedback userId={props.data.id} />
          </div>
          <div className='bottonDivider mb-3'></div>
          <div className='mb-3'>
              <VendorDetails user={props.data} />
          </div>
          
        </div>
        {
          props.data.description &&
            <div className={`${styles.about} p-4`}>
                <div>
                  <div className={`${styles.title}`}>
                    About Seller
                  </div>
                    {parse(props.data.description)}
                </div>
            </div>
        }
      </div>
    </vendor-card-component>
  )
}
